module.exports = __webpack_public_path__ + "static/img/13.12a74ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/13.png
// module id = fmho
// module chunks = 4